import object from 'helpers/object'


export const initialState = {
  areas: [],
  tools: {},
  toolTypes: [],
  toolsByType: {},
  isFetching: true,
}


export const setAreas = (state, payload) => (
  object.setIn(state, [ 'areas' ], payload)
)

export const setAreaTools = (state, payload) => (
  object.setIn(state, [ 'tools', payload.areaId ], payload.tools)
)

export const setToolTypes = (state, payload) => (
  object.setIn(state, [ 'toolTypes' ], payload)
)

export const setToolsByType = (state, payload) => (
  object.setIn(state, [ 'toolsByType', payload.type ], payload.tools)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
